import { apiFetch, withQuery } from '@/app/apiClient';

import {
  SCENARIOS_ENDPOINTS,
  type ScenarioRow,
  type ScenarioVersionRow,
  type ScenariosApi,
} from './api';

/**
 * Real HTTP client for the Scenario catalog screen. Talks to `sentinel-api`
 * via the `/api/v1/scenarios*` routes declared in `./api.ts`.
 */
export function createFetchScenariosApi(): ScenariosApi {
  return {
    listScenarios: async (query) =>
      apiFetch<ScenarioRow[]>(
        withQuery(SCENARIOS_ENDPOINTS.list, {
          status: query.status,
          sourcePlatform: query.sourcePlatform,
          q: query.q,
        }),
      ),
    getScenario: async (id) =>
      apiFetch<ScenarioRow | null>(SCENARIOS_ENDPOINTS.byId(encodeURIComponent(id as unknown as string))),
    listVersions: async (id) =>
      apiFetch<ScenarioVersionRow[]>(
        SCENARIOS_ENDPOINTS.versions(encodeURIComponent(id as unknown as string)),
      ),
  };
}
